import {
  BONUSES_HISTORY,
  BONUSES_LIST,
} from '../../../constants/routeTemplates';
import { ALL_BONUSES_CATEGORY, BONUSES_HISTORY_CATEGORY } from './index';

export const getBonusesCategoryPath = (categoryId) => {
  switch (categoryId) {
    case BONUSES_HISTORY_CATEGORY:
      return BONUSES_HISTORY;
    case ALL_BONUSES_CATEGORY:
      return BONUSES_LIST;
    default:
      return `${BONUSES_LIST}?category=${categoryId}`;
  }
};
